exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-title-contianer__title-container[data-v-2e33b56f]{margin:0;color:#3aa1ca}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e33b56f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/followair/atualizacao-manual/components/sectionTitle/sectionTitleContainer.vue
// module id = 550
// module chunks = 0